import { Alert } from '@mui/material'

const NoSearch = ({ items, label }: { items?: string; label?: string }) => {
  return (
    <Alert severity="info" className="my-3 font-weight-bold">
      {label ? label : `Realice una búsqueda para ver los ${items}`}
    </Alert>
  )
}

export default NoSearch
